import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { EventSlot } from "../../../library-js/events/EventSlot";
import { isOneOf } from "../../../library-js/tools/isOneOf";
import { LoadingState } from "../../../library-js/tools/LoadingState";
import { loadScript, PayPalButtonsComponentOptions, PayPalNamespace, PurchaseUnit, PurchaseItem } from "@paypal/paypal-js";
import { Rokojori } from "../../js/Rokojori";


export class PaypalCheckout
{
  static readonly type      = new ElementType( "paypal-checkout" );
  static readonly buttons   = new ElementType<HTMLElement>( "paypal-buttons" );
  static readonly clientID  = "AeETfo7RupUP0Id5c1VtkODgPYS_kfeI1cYT8fUsuM4jLUoWB2xyyw7vTG4oKo-AtGtnbQ7oKD1RcrXc";
  static readonly paypalURL = "http://localhost:1780";

  static readonly createOrderPath   = "create-order";
  static readonly completeOrderPath = "complete-order";
  
  static applyOnDocument()
  { 
    PaypalCheckout.type.forAllInDoc( e => this.applyOnElement( e as HTMLElement, PaypalCheckout.clientID ) );
  }

  static async applyOnElement( element:HTMLElement,  clientID:string )
  {    
    let paypal:PayPalNamespace;    

    try 
    {
      paypal = await loadScript( { "client-id": clientID, currency: "EUR" } );
    } 
    catch  (error ) 
    {
      console.error( "failed to load the PayPal JS SDK script", error );
    }

    if ( ! paypal )
    {
      console.error( "Paypal couldn't be initialized" );
      return;
    } 

    let buttons = PaypalCheckout.buttons.query( element );
    let intent = "capture";

    let cartID = await Rokojori.$.assetManagerServer.assetsCart.getSessionID();

    let ids = [ cartID.id ];

    let paypalButtons = await paypal.Buttons(
      {

        createOrder: async ( data, actions ) => 
        {
          let createOrderResponse = await fetch( 
            PaypalCheckout.paypalURL + "/" + PaypalCheckout.createOrderPath, 
            {
              method: "post", 
              headers: { "Content-Type": "application/json; charset=utf-8" },
              body: JSON.stringify( { intent: intent, purchaseIDs:ids } )
            }            
          );

         
          let createOrderData = await createOrderResponse.json();

          console.log( createOrderData )

          return Promise.resolve( createOrderData.order_id );
        }, 

        onApprove: async ( data, actions ) =>
        {
          let completeOrderResponse = await fetch( 
            PaypalCheckout.paypalURL + "/" + PaypalCheckout.completeOrderPath, 
            {
              method: "post", 
              headers: { "Content-Type": "application/json; charset=utf-8" },
              body: JSON.stringify( { "intent": intent, "order_id": data.orderID } )
            }            
          );

          let orderDetails = await completeOrderResponse.json();

          console.log( "OrderDetails:", orderDetails ); 

          paypalButtons.close();        
        }
      }
    );
    
    paypalButtons.render( buttons );
    
  }

  

}